var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrostedgrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 869,
    height: 841,
    viewBox: "0 0 869 841",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5249_5379)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 3.53876,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 39.811,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 76.0832,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 112.355,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 148.628,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 184.9,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 221.172,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 257.444,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 293.717,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 329.989,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 366.261,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 402.533,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 438.806,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 475.078,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 511.35,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 547.622,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 583.895,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 620.167,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 656.439,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 692.711,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 728.984,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 765.256,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.53876,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.0833,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.628,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.172,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.717,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.261,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.806,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 511.35,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.895,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.439,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 728.984,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.528,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.355,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.9,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.444,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.989,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.534,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.078,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547.622,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.167,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.711,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.256,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.8,
    cy: 801.528,
    r: 3.53876,
    fill: "white",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5249_5379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 869,
    height: 841,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrostedgrid);
export default __webpack_public_path__ + "static/media/frostedgrid.226703fa699304d6bebffbcd547729bb.svg";
export { ForwardRef as ReactComponent };